import styled from 'styled-components';

const CommentBackground = styled.div`
  padding: 40px;
  background-color: rgba(0, 0, 0, 0.04);
`;

export default CommentBackground;
